import { Mail } from 'lucide-react';
import { AuthShell } from './AuthShell';

export default function MustVerify() {
  return (
    <AuthShell title="Check your email" subtitle="Account creation successful.">
      <div className="p-6 flex flex-col items-center text-center">
        <div className="w-12 h-12 rounded-full bg-brand-soft flex items-center justify-center text-brand mb-4">
          <Mail className="w-5 h-5" />
        </div>
        <p className="text-sm text-foreground">
          We sent a verification email. Click the link in it to continue with account setup.
        </p>
      </div>
    </AuthShell>
  );
}
